/*
* extension functions for AQD jqGrid preferences
*/
(function ($) {
  var methods = {
    addColumnSelectButton: function (options) {
      var settings = $.extend({
        'buttonTitle': "Select/Order Columns",
        'preferencesUrl': ""
      }, options);

      return this.each(function () {
        var $this = $(this);
        var gridId = $this.attr('id');
        $this.navButtonAdd("#" + gridId + "_pager", {
          id: "btnNewCols" + gridId,
          buttonicon: 'ui-icon-selectcol',
          position: 'last',
          title: settings.buttonTitle,
          onClickButton: function () {
              var origWidth = $this.getGridParam("width");
            $this.columnChooser({
              dlog_opts: function (opts) {
                var buttons = {};
                var optionsUrl = settings.preferencesUrl.replace("Save", "Options");
                var colOneData = [];
                var optData;
                colOneData[0] = { GridName: gridId, ColumnName: 'ResetGridOptions' };
                $.ajax({
                  type: "GET",
                  url: optionsUrl,
                  dataType: "json",
                  async: false,
                  success: function (data) {
                    optData = data;
                  }
                });
                buttons[opts.bCancel] = function () {
                  opts.cleanup(true);
                };
                buttons[opts.bSubmit] = function () {
                  opts.apply_perm();
                  opts.cleanup(false);
                };
                buttons["Reset"] = function () {
                  $.confirmDialog(optData.confirmMessage, optData.confirmTitle, function () {
                    var resetUrl = settings.preferencesUrl.replace("Save", "Reset");
                    $.post(resetUrl, { gridName: gridId, colName: 'ResetGridOptions' }, function () { location.reload(); });                    
                  });
                };
                return {
                  "buttons": buttons,
                  "close": function () {
                    opts.cleanup(true);
                  },
                  "modal": true,
                  "resizable": opts.resizable ? opts.resizable : true,
                  "width": opts.width + 20
                };
              },
              done: function (colOrder) {
                if (colOrder) { $this.jqGrid("remapColumns", colOrder, true); }
                var colModel = $this.jqGrid("getGridParam", "colModel");
                var colData = [];
                var optionName = '#colchooser_' + gridId;
                $('option', optionName).each(function (i) {
                  var cData = { GridName: gridId, ColumnName: colModel[this.value].name, Selected: this.selected };
                  colData[this.value] = cData;
                });
                $.ajax({
                  url: settings.preferencesUrl,
                  type: 'POST',
                  contentType: 'application/json; charset=utf-8',
                  dataType: 'json',
                  data: JSON.stringify(colData)
                });
                  $this.setGridWidth(origWidth);
              }
            });
            var gridname = "#colchooser_" + $(this)[0].id;
            $(gridname).AddHelpContext('{78E5FFD9-A725-4356-B3BB-E631E411E6CC}', '{141BACE2-102D-4b76-9913-9FFFA4628821}');
          }
        });
      });
    },
    setSavedColumns: function (options) {
      var settings = $.extend({
        'preferencesUrl': "",
        'findSavedColumnIndex': function (cols, item) {
          for (var c in cols) {
            if (cols[c].name == item.ColumnName) {
              return c;
            }
          }

          return 0;
        }
      }, options);
      
      return this.each(function () {
        var $this = $(this);
        var gridId = $this.attr('id');
        var origWidth = $this.getGridParam("width");
        $this.setGridParam({ shrinkToFit: false });
        var ax = $.get(settings.preferencesUrl, { gridName: gridId }, function () { }, "json")
         .success(function (data) {
           if (data.length > 0) {
             for (var c in data) {
               if (data[c].Selected) {
                 $this.jqGrid("showCol", data[c].ColumnName);
               } else {
                 $this.jqGrid("hideCol", data[c].ColumnName);
               }
             }
             var perm = [];

             var colModel = $this.jqGrid("getGridParam", "colModel");
             // If we don't check for subgrid, it seems to duplicate the last column
             if (colModel[0].name == 'subgrid' || colModel[0].name == 'cb')
             	perm[0] = 0;
	           for (var i in data) {
	           	if (data.hasOwnProperty(i)) {
			          // var indexOffset = colModel[0].name == 'cb' ? 1 : 0;
			           perm[perm.length] = parseInt(settings.findSavedColumnIndex(colModel, data[i]), 10);// + indexOffset;
		           }
	           }
	           $this.jqGrid("remapColumns", perm, true);                     
           }
           $this.setGridWidth(origWidth);      
         })
         .error(function () { })
         .complete(function () { });
      });
    },
    linkFromGridItem: function (options) {
      var settings = $.extend({
        'targetUrl': "",
        'paramString': "",
        'displayString': "",
        'gridId': "",
        'gridParamName': "sourceGrid",
        'argPrefix': "?"
      }, options);

      var targetLink = settings.targetUrl;
      if (settings.paramString) {
        targetLink = targetLink + "?" + settings.paramString;
        settings.argPrefix = "&";
      }

      targetLink = targetLink + settings.argPrefix + settings.gridParamName + "=" + settings.gridId;
      return "<a href='" + targetLink + "'>" + settings.displayString + "</a>";
    }    
  };

  $.fn.gridPreferences = function (method) {
    // Method calling logic
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.gridPreferences');
    }
  };
  $.fn.addRowHighlight = function (filterCellsFunction, columnName) {
      var $this = $(this);      
      var targetCol = $this.attr('id') + "_" + columnName;
      $this.find("tbody tr td[aria-describedby='"+ targetCol + "']").filter(filterCellsFunction).parent("tr").addClass("rowhighlighted");
  };
  $.fn.loadOnDemand = function (hasRunDictionary) {
      var $this = $(this);
      var gridId = $this.attr('id');      
      if (hasRunDictionary != null && hasRunDictionary.getValue(gridId) != "true") {
          $this.setGridParam({ datatype: 'json' });
          $this.trigger("reloadGrid");
          hasRunDictionary.setValue(gridId, "true");
      }
      if (hasRunDictionary == null) {
          $this.setGridParam({ datatype: 'json' });
          $this.trigger("reloadGrid");
      }
  };
    $.fn.updatePanelHeaders = function(id, title, hasRunDictionary) {
        //get the grid record count
        var sectionTotal = 0;
        var gridId = $(this).attr('id');
        if (hasRunDictionary.getValue(gridId) == "true") {
            $("#Section_Contents" + id + " .ui-jqgrid-btable").each(function () {
              
                var cnt = $(this).getGridParam("records");
                
                if ($(this).getGridParam("datatype") == 'local') {
                    // Need to extract from the title instead.... 
                    var data = /\((\d+)\)/.exec($(this).parents('.ui-collapsible:first').find('h3').text());
                    
                    if (data != null)
                    cnt = parseInt(data[1]);
                }
                sectionTotal += cnt;
            });
            $("#PanelTitle_" + id)[0].innerHTML = title + " (" + sectionTotal + ")";
        }
    };
})(jQuery);